import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

const config = {
    apiKey: "AIzaSyBPWEHbVaZk3rIT8bYyIIeDTis4TIcUrUs",
    authDomain: "treasurehunt-a20a0.firebaseapp.com",
    databaseURL: "https://treasurehunt-a20a0.firebaseio.com",
    projectId: "treasurehunt-a20a0",
    storageBucket: "gs://treasurehunt-a20a0.appspot.com",
    messagingSenderId: "133249047582"
};

if (!firebase.apps.length) {
    firebase.initializeApp(config);
}

const auth = firebase.auth();
const firestore = firebase.firestore();
const storage = firebase.storage();

export {
   auth,
   firestore,
   storage
};




// WEBPACK FOOTER //
// ./src/firebase/firebase.js